export default [
  {
    name: 'unit-group-create',
    path: '/units/groups/create',
    component: () => import('@/views/groups/GroupsManage'),
    props: { groupType: 'unit' }
  },
  {
    name: 'unit-group-edit',
    path: '/units/groups/:id/edit',
    component: () => import('@/views/groups/GroupsManage'),
    props: { groupType: 'unit' }
  },
  {
    name: 'unit-group-view',
    path: '/units/groups/:id/view',
    component: () => import('@/views/groups/GroupsManage'),
    props: { groupType: 'unit' }
  },
  {
    name: 'unit-group-find',
    path: '/units/groups/find',
    component: () => import('@/views/groups/GroupsFind'),
    props: { groupType: 'unit' }
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUnitGroups.js